/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Fond_Ape_SoarInputs */

const en_shy_fond_ape_soar = /** @type {(inputs: Shy_Fond_Ape_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History of the user's survey participations`)
};

const de_shy_fond_ape_soar = /** @type {(inputs: Shy_Fond_Ape_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf der bisherigen Umfrage-Teilnahmen des Benutzers`)
};

/**
* | output |
* | --- |
* | "History of the user's survey participations" |
*
* @param {Shy_Fond_Ape_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_fond_ape_soar = /** @type {((inputs?: Shy_Fond_Ape_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Fond_Ape_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_fond_ape_soar(inputs)
	return de_shy_fond_ape_soar(inputs)
});